'use strict';

module Patersons {

    export class StandardLedgerReport extends AbstractReport {
        ledgerEntries: LedgerEntry[];
    }

    export class LedgerEntry{
        account: string;
        ledgerDate: Date;
        type: string;
        currency: string;
        balance: number;
        amount: number;
        reference: string;
        description: string;
        isOpen: number;
        isCancelled: number;
    }

    export class StandardLedgerReportComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/standardLedgerReport.component.html';
        controller: any = StandardLedgerReportController;
        bindings: any = {
            report: '<',
            title: '@'
        };
    }

    export class StandardLedgerReportController extends AbstractReportController {
        report: StandardLedgerReport;
    }

}